import React, { useCallback } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import { Flex, Select, TextInput } from '@mantine/core';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import Button from '../Button';

interface ToolBoxProps {
  placeholder?: string;
  placeholderSelect?: string;
  handleSearch: (data: any) => void;
  handleSelect?: (data: any) => void;
  buttonOnClick?: () => void;
  dropdownOptions?: any[];
  isSortingDate?: boolean;
  withButton?: boolean;
  withSelect?: boolean;
  buttonText?: string;
  valueSelect?: string;
}

const ToolBox: React.FC<ToolBoxProps> = ({
  placeholder = 'Search by name',
  placeholderSelect = 'Select data',
  dropdownOptions,
  isSortingDate,
  handleSelect,
  handleSearch,
  buttonText = 'Create',
  withButton = true,
  withSelect = false,
  buttonOnClick,
  valueSelect
}) => {
  const handleSearchWithDelay = useCallback(debounce(handleSearch, 1000), [
    handleSearch
  ]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearchWithDelay(event.target.value);
  };

  return (
    <section className="toolbox-container" style={{ margin: 0 }}>
      <div className="toolbox-container--left">
        <Flex align="center">
          <TextInput
            placeholder={placeholder}
            radius="md"
            leftSection={<Unicons.UilSearch />}
            onChange={handleInputChange}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                handleSearch(e.target.value);
              }
            }}
          />
          {isSortingDate && (
            <TextInput
              placeholder={placeholder}
              radius="md"
              type="date"
              ml={4}
              onChange={handleInputChange}
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  handleSearch(e.target.value);
                }
              }}
            />
          )}
        </Flex>
        {withSelect && (
          <Select
            disabled={dropdownOptions?.length === 0}
            data={[{ label: placeholderSelect, value: '' }, ...dropdownOptions]}
            placeholder={placeholderSelect}
            onChange={handleSelect}
            value={valueSelect}
          />
        )}
      </div>

      {withButton && <Button onClick={buttonOnClick}>{buttonText}</Button>}
    </section>
  );
};

export default ToolBox;

export function debounce(func: Function, delay: number) {
  let timeoutId: NodeJS.Timeout;
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
}
